export default __webpack_public_path__ + "../staticImages/diamant_gold.png";